import Button from './styledComponent';

Button.defaultProps = {
  type: 'primary',
};

export default Button;
